export { default } from './ClassPassList';

